// extracted by mini-css-extract-plugin
export default {"Text":"TermsAndConditions_Text__BvUVi"};